import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { readPendingMcpAuthorize } from 'app/core/utils/mcp-authorize.util';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard {
  constructor(
    private _authService: AuthService,
    private _router: Router
  ) {}

  //==========================================================
  //? @PUBLIC METHODS
  //==========================================================

  /**
   * Can match
   *
   * @param route
   * @param segments
   */
  canMatch(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._check();
  }

  //==========================================================
  //? @PRIVATE METHODS
  //==========================================================

  /**
   * Check the authenticated status
   *
   * @private
   */
  private _check(): Observable<boolean> {
    // MCP OAuth handoff: an already-authenticated user must still reach /auth/sign-in when the
    // OAuth server sent them here, so the page can complete the handoff with the existing session
    // instead of being bounced to the dashboard. (The mcp_authorize params were captured to
    // storage in main.ts before MSAL stripped them from the URL.)
    if (readPendingMcpAuthorize()) {
      return of(true);
    }

    // Check the authentication status and return an observable of
    // "true" or "false" to allow or prevent the access
    return this._authService.check().pipe(switchMap((authenticated) => of(!authenticated)));
  }
}
